export default __webpack_public_path__ + "static/media/avatar_dog2.a5d8f910.mp3";